import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { DepotInActions } from "../../../../depot-in/depot-in.actions";
import { DepotOutActions } from "../../../../depot-out/depot-out.actions";
import { ActionTemplateScreen } from "../../../action.template.screen.enum";
import { PlanningBlock } from "../../../models/planning-block/planning-block.interface";
import { SharedService } from "../../../services/shared.service";
import { SharedActions } from "../../../shared.actions";
import {
  ActionTemplateAddress,
  ActionTemplateInsertLineResultViewModel,
  ActionTemplateInsertLineViewModel,
  RerouteModel
} from "./reroute-modal.interface";
import { ModalManagerService } from "../../../services/modal-manager.service";
import { ModalType } from "../../../models/component-source";
import { HttpClientService } from "../../../services/httpclient";
import { MsalService } from "../../../../msal";
import { select } from "@angular-redux/store";
import { ApplicationUser } from "../../../../pb-screen/models/application.user.interface";
import { Observable, Subject } from "rxjs-compat";
import { takeUntil } from "rxjs/operators";
import { UserFeedbackService } from "../../../../services/user-feedback.service";


@Component({
  selector: "reroute-modal",
  templateUrl: "reroute-modal.component.html",
})

export class RerouteModalComponent implements OnInit, OnDestroy {
  public actionTemplateAddresses: ActionTemplateAddress[] = [];
  public actionTemplateAddressesListItems: any[] = [];
  public actionTemplates: string[];
  public isLoadingRerouteAddress: boolean = true;
  public modalType = ModalType;
  @select("loading") public loading$: Observable<boolean>;
  @select("applicationUser") public applicationUser$: Observable<ApplicationUser>;
  public enableAutocomplete: boolean = false;
 public loading: boolean = false;
  @Input() public planningBlocks: PlanningBlock[];
  @Input() public actionTemplateScreen: ActionTemplateScreen;
  @Output() public onRerouteSucceeded: EventEmitter<boolean> = new EventEmitter<boolean>();

  public rerouteModel: RerouteModel = {
    action: "",
    addressNo: {
      id: "",
      value: "",
    },
  };

  destroy$ = new Subject();

  constructor(
    private readonly sharedService: SharedService,
    private readonly sharedActions: SharedActions,
    private readonly depotInActions: DepotInActions,
    private readonly depotOutActions: DepotOutActions,
    private readonly userFeedbackService: UserFeedbackService,
    private readonly modalManager: ModalManagerService,
    private readonly authService: MsalService,
    public readonly httpClientService: HttpClientService
  ) {
  }

  public ngOnInit(): void {
    this.httpClientService.getToken().subscribe(_ => {
      this.getActionTemplatesForRerouteAutocomplete();
      this.applicationUser$.pipe(takeUntil(this.destroy$)).subscribe((applicationUser: ApplicationUser) => {
        if (applicationUser) {
          this.enableAutocomplete = applicationUser.generalSetting.enableAutocomplete;
        }
      });
    });


    this.loading$.subscribe((data) => {
      if (!data) {
        this.loading = data;
      }
    });

  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public getActionTemplatesForRerouteAutocomplete(): void {
    this.sharedService.getActionTemplates(this.actionTemplateScreen).subscribe((actionTemplates: string[]) => {
      if (actionTemplates && actionTemplates.length > 0) {
        this.actionTemplates = actionTemplates;
      }
    });
  }

  public onActionTemplateSelected(): void {
    this.isLoadingRerouteAddress = true;
    if (this.rerouteModel.action) {
      this.sharedService.getActionTemplateAddresses(this.rerouteModel.action)
        .subscribe((actionTemplateAddresses: ActionTemplateAddress[]) => {
          if (actionTemplateAddresses && actionTemplateAddresses.length > 0) {
            this.actionTemplateAddresses = actionTemplateAddresses;
            this.actionTemplateAddressesListItems = actionTemplateAddresses.map((x) => {
              return {
                id: x.no,
                value: x.name,
              };
            }).filter((v, i, a) => a.indexOf(v) === i);
            this.isLoadingRerouteAddress = false;
          }
        });
    }
  }

  public onConfirmClicked(): void {

    this.sharedActions.setLoading(true);

    const account = this.authService.getAccount();

    if (account.username) {
      const planningBlockIds: number[] = this.planningBlocks.map((x) => x.id);
      const actionTemplateInsertLineViewModel: ActionTemplateInsertLineViewModel = {
        actionTemplateCode: this.rerouteModel.action,
        addressNo: this.rerouteModel.addressNo.id,
        planningBlockIds,
        userId: account.username
      };
      this.loading = true;
      this.sharedService.insertActionTemplateLines(actionTemplateInsertLineViewModel)
        .subscribe((actionTemplateInsertLineResultViewModel: ActionTemplateInsertLineResultViewModel) => {

          this.onRerouteSucceeded.emit(true);
          this.sharedActions
            .updatePlanningBlocksDisplayCpl([...actionTemplateInsertLineResultViewModel.updatedPlanningBlocks]);
          this.sharedActions
            .addPlanningBlocksDisplay(actionTemplateInsertLineResultViewModel.newPlanningBlocksViewModel);
          this.userFeedbackService.showSuccessMessage("TOASTR_MESSAGES.SUCCESS.REROUTING_COMPLETED_SUCCESFULLY");
          this.depotInActions.setDepotInSelection([]);
          this.depotOutActions.setDepotOutSelection([]);

          this.resetUi();
          this.loading = false;
        } , error => {

          this.loading = false;
          this.resetUi();
        });


    }
  }

  public onCancelClicked(): void {
    this.resetUi();
  }

  public resetUi(): void {
    this.sharedActions.setUiState(true);
    this.modalManager.closeModal(this.modalType.reroute);
    this.rerouteModel = {
      action: "",
      addressNo: {
        id: "",
        value: "",
      },
    };
  }
}
